import { addPermissionsToRoute } from '@qsrsoft/myq-core';
import { MT_ENTERPRISES } from '../mtEnterprises';

const routes = {
  name: 'Labor',
  icon: 'mdi-account-group-outline',
  path: '/reports/labor',
  ...addPermissionsToRoute(['mtLabor']),

  // MT-only sidebar group (no McDonald's ZA equivalent). Plain `TimHortons`
  // is excluded by omission from mtEnterprises.js.
  menuFilters: {
    $and: [
      { countryCode: { $in: ['us', 'ca'] } },
      { enterpriseClient: { $in: MT_ENTERPRISES } },
    ],
  },
  children: [
    {
      path: '/reports/labor/crewTraining',
      name: 'Crew Training',
      component: () => import('./CrewTraining.vue'),
      meta: {
        id: 'reports-mtLaborCrewTraining',
      },
    },
    {
      path: '/reports/labor/dailyLaborHours',
      name: 'Daily Labor Hours',
      component: () => import('./DailyLaborHours.vue'),
      meta: {
        id: 'reports-mtLaborDailyLabor',
      },
    },
    {
      path: '/reports/labor/weeklyLaborHours',
      name: 'Weekly Labor Hours',
      component: () => import('./WeeklyLaborHours.vue'),
      meta: {
        id: 'reports-mtWeeklyLaborHours',
      },
    },
    {
      path: '/reports/labor/laborSummary',
      name: 'Labor Summary %',
      component: () => import('./LaborWrapper.vue'),
      props: () => ({ defaultTab: 'summary' }),
      permissions: ['thLaborSummary'],
    },
    {
      path: '/reports/labor/laborSchedules',
      name: 'Labor Schedules',
      component: () => import('../../standard/labor/LaborSchedules.vue'),
      permissions: ['thLaborSchedules'],
    },
    {
      path: '/reports/labor/laborDetails',
      name: 'Labor Reports',
      meta: { id: 'reports-laborDetails' },
      component: () => import('./LaborWrapper.vue'),
      props: () => ({ defaultTab: 'details' }),
      ...addPermissionsToRoute(['laborStatistics']),
    },
    {
      path: '/reports/labor/laborStatistics',
      name: 'Labor Statistics',
      meta: { id: 'reports-laborStatistics' },
      component: () => import('./LaborStatistics.vue'),
      ...addPermissionsToRoute(['laborStatistics']),
    },
    {
      path: '/reports/mcd/controlsLabor/laborAnalysis',
      name: 'Labor Analysis',
      component: () => import('./labor-analysis.vue'),
      ...addPermissionsToRoute(['laborStatistics']),
      meta: { id: 'reports-laborAnalysis' },
    },
    // {
    //   path: '/reports/mcd/controlsLabor/laborAnalysis',
    //   name: 'Labor Analysis',
    //   meta: { id: 'reports-laborAnalysis', permission: 'mtLabor' },
    //   component: () => import('./labor-analysis.vue'),
    //   ...addPermissionsToRoute(['mtLabor']),
    // },
  ],
};

export default routes;
